module.exports = __webpack_public_path__ + "static/story4-menu-thumbnails-400x400-d442a4c993576158e9e26f0f2912d4a1.jpg";